/* tslint:disable */
/* eslint-disable */
/* @relayHash 264a42a5a8a4976dd2e8f9420158c3fe */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type RefreshSettingsFetchQueryVariables = {
    storyID: string;
    flattenReplies: boolean;
};
export type RefreshSettingsFetchQueryResponse = {
    readonly settings: {
        readonly " $fragmentRefs": FragmentRefs<"StreamContainer_settings" | "PermalinkViewContainer_settings">;
    };
    readonly story: {
        readonly closedAt: string | null;
        readonly isClosed: boolean;
    } | null;
};
export type RefreshSettingsFetchQuery = {
    readonly response: RefreshSettingsFetchQueryResponse;
    readonly variables: RefreshSettingsFetchQueryVariables;
};



/*
query RefreshSettingsFetchQuery(
  $storyID: ID!
  $flattenReplies: Boolean!
) {
  settings {
    ...StreamContainer_settings
    ...PermalinkViewContainer_settings
    id
  }
  story(id: $storyID) {
    closedAt
    isClosed
    id
  }
}

fragment AnnouncementContainer_settings on Settings {
  announcement {
    id
    content
  }
}

fragment CaretContainer_settings on Settings {
  ...ModerationDropdownContainer_settings
}

fragment CommentContainer_settings on Settings {
  disableCommenting {
    enabled
  }
  featureFlags
  ...CaretContainer_settings
  ...EditCommentFormContainer_settings
  ...MediaSectionContainer_settings
  ...ReactionButtonContainer_settings
  ...ReplyCommentFormContainer_settings
  ...ReportFlowContainer_settings
  ...UsernameWithPopoverContainer_settings
  ...UserTagsContainer_settings
}

fragment CommunityGuidelinesContainer_settings on Settings {
  communityGuidelines {
    enabled
    content
  }
}

fragment ConversationThreadContainer_settings on Settings {
  ...CommentContainer_settings
  ...LocalReplyListContainer_settings
  ...UserTagsContainer_settings
}

fragment EditCommentFormContainer_settings on Settings {
  charCount {
    enabled
    min
    max
  }
  media {
    twitter {
      enabled
    }
    youtube {
      enabled
    }
    giphy {
      enabled
      key
      maxRating
    }
    external {
      enabled
    }
  }
  rte {
    ...RTEContainer_config
  }
}

fragment LocalReplyListContainer_settings on Settings {
  ...ReplyListCommentContainer_settings
}

fragment MediaSectionContainer_settings on Settings {
  media {
    twitter {
      enabled
    }
    youtube {
      enabled
    }
    giphy {
      enabled
    }
    external {
      enabled
    }
  }
}

fragment ModerateStreamContainer_settings on Settings {
  auth {
    integrations {
      sso {
        enabled
        targetFilter {
          admin
        }
      }
    }
  }
}

fragment ModerationActionsContainer_settings on Settings {
  auth {
    integrations {
      sso {
        enabled
        targetFilter {
          admin
        }
      }
    }
  }
}

fragment ModerationDropdownContainer_settings on Settings {
  ...ModerationActionsContainer_settings
  ...UserBanPopoverContainer_settings
}

fragment PermalinkViewContainer_settings on Settings {
  ...ConversationThreadContainer_settings
  ...ReplyListContainer1_settings
  ...UserBoxContainer_settings
}

fragment PostCommentFormContainer_settings on Settings {
  charCount {
    enabled
    min
    max
  }
  disableCommenting {
    enabled
    message
  }
  closeCommenting {
    message
  }
  media {
    twitter {
      enabled
    }
    youtube {
      enabled
    }
    giphy {
      enabled
      key
      maxRating
    }
    external {
      enabled
    }
  }
  rte {
    ...RTEContainer_config
  }
}

fragment PreviousCountSpyContainer_settings on Settings {
  featureFlags
}

fragment RTEContainer_config on RTEConfiguration {
  enabled
  strikethrough
  spoiler
  sarcasm
}

fragment ReactionButtonContainer_settings on Settings {
  reaction {
    label
    labelActive
    icon
    iconActive
  }
}

fragment ReplyCommentFormContainer_settings on Settings {
  charCount {
    enabled
    min
    max
  }
  disableCommenting {
    enabled
    message
  }
  closeCommenting {
    message
  }
  media {
    twitter {
      enabled
    }
    youtube {
      enabled
    }
    giphy {
      enabled
      key
      maxRating
    }
    external {
      enabled
    }
  }
  rte {
    ...RTEContainer_config
  }
}

fragment ReplyListCommentContainer_settings on Settings {
  ...CommentContainer_settings
}

fragment ReplyListContainer1_settings on Settings {
  disableCommenting {
    enabled
  }
  ...ReplyListCommentContainer_settings
  ...ReplyListContainer2_settings
}

fragment ReplyListContainer2_settings on Settings {
  disableCommenting {
    enabled
  }
  ...ReplyListCommentContainer_settings
  ...ReplyListContainer3_settings
}

fragment ReplyListContainer3_settings on Settings {
  disableCommenting {
    enabled
  }
  ...ReplyListCommentContainer_settings
  ...ReplyListContainerLast_settings
}

fragment ReplyListContainerLastFlattened_settings on Settings {
  disableCommenting {
    enabled
  }
  ...ReplyListCommentContainer_settings
}

fragment ReplyListContainerLast_settings on Settings {
  ...LocalReplyListContainer_settings @skip(if: $flattenReplies)
  ...ReplyListContainerLastFlattened_settings @include(if: $flattenReplies)
}

fragment ReportCommentFormContainer_settings on Settings {
  memberBios
}

fragment ReportFlowContainer_settings on Settings {
  ...ReportCommentFormContainer_settings
}

fragment StaffTagContainer_settings on Settings {
  staff {
    staffLabel
    adminLabel
    moderatorLabel
  }
}

fragment StreamContainer_settings on Settings {
  reaction {
    sortLabel
  }
  featureFlags
  disableCommenting {
    enabled
  }
  ...AnnouncementContainer_settings
  ...CommunityGuidelinesContainer_settings
  ...ModerateStreamContainer_settings
  ...PostCommentFormContainer_settings
  ...PreviousCountSpyContainer_settings
  ...SuspendedInfoContainer_settings
  ...UserBoxContainer_settings
  ...ViewersWatchingContainer_settings
}

fragment SuspendedInfoContainer_settings on Settings {
  organization {
    name
  }
}

fragment UserBanPopoverContainer_settings on Settings {
  featureFlags
}

fragment UserBoxContainer_settings on Settings {
  auth {
    integrations {
      local {
        enabled
        allowRegistration
        targetFilter {
          stream
        }
      }
      oidc {
        enabled
        allowRegistration
        targetFilter {
          stream
        }
      }
      google {
        enabled
        allowRegistration
        targetFilter {
          stream
        }
      }
      facebook {
        enabled
        allowRegistration
        targetFilter {
          stream
        }
      }
    }
  }
}

fragment UserPopoverContainer_settings on Settings {
  ...UserPopoverOverviewContainer_settings
}

fragment UserPopoverOverviewContainer_settings on Settings {
  memberBios
}

fragment UserTagsContainer_settings on Settings {
  ...StaffTagContainer_settings
}

fragment UsernameWithPopoverContainer_settings on Settings {
  ...UserPopoverContainer_settings
}

fragment ViewersWatchingContainer_settings on Settings {
  disableCommenting {
    enabled
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = ({
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "flattenReplies"
    } as any), v1 = ({
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "storyID"
    } as any), v2 = [
        ({
            "kind": "Variable",
            "name": "id",
            "variableName": "storyID"
        } as any)
    ], v3 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "closedAt",
        "storageKey": null
    } as any), v4 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isClosed",
        "storageKey": null
    } as any), v5 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "enabled",
        "storageKey": null
    } as any), v6 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
    } as any), v7 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any), v8 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "content",
        "storageKey": null
    } as any), v9 = [
        (v5 /*: any*/),
        ({
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "allowRegistration",
            "storageKey": null
        } as any),
        ({
            "alias": null,
            "args": null,
            "concreteType": "AuthenticationTargetFilter",
            "kind": "LinkedField",
            "name": "targetFilter",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "stream",
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any)
    ], v10 = [
        (v5 /*: any*/)
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                (v0 /*: any*/),
                (v1 /*: any*/)
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "RefreshSettingsFetchQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Settings",
                    "kind": "LinkedField",
                    "name": "settings",
                    "plural": false,
                    "selections": [
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "StreamContainer_settings"
                        },
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "PermalinkViewContainer_settings"
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": (v2 /*: any*/),
                    "concreteType": "Story",
                    "kind": "LinkedField",
                    "name": "story",
                    "plural": false,
                    "selections": [
                        (v3 /*: any*/),
                        (v4 /*: any*/)
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                (v1 /*: any*/),
                (v0 /*: any*/)
            ],
            "kind": "Operation",
            "name": "RefreshSettingsFetchQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Settings",
                    "kind": "LinkedField",
                    "name": "settings",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "ReactionConfiguration",
                            "kind": "LinkedField",
                            "name": "reaction",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "sortLabel",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "label",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "labelActive",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "icon",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "iconActive",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "featureFlags",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "DisableCommenting",
                            "kind": "LinkedField",
                            "name": "disableCommenting",
                            "plural": false,
                            "selections": [
                                (v5 /*: any*/),
                                (v6 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Announcement",
                            "kind": "LinkedField",
                            "name": "announcement",
                            "plural": false,
                            "selections": [
                                (v7 /*: any*/),
                                (v8 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "CommunityGuidelines",
                            "kind": "LinkedField",
                            "name": "communityGuidelines",
                            "plural": false,
                            "selections": [
                                (v5 /*: any*/),
                                (v8 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Auth",
                            "kind": "LinkedField",
                            "name": "auth",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "AuthIntegrations",
                                    "kind": "LinkedField",
                                    "name": "integrations",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "SSOAuthIntegration",
                                            "kind": "LinkedField",
                                            "name": "sso",
                                            "plural": false,
                                            "selections": [
                                                (v5 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "AuthenticationTargetFilter",
                                                    "kind": "LinkedField",
                                                    "name": "targetFilter",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "admin",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "LocalAuthIntegration",
                                            "kind": "LinkedField",
                                            "name": "local",
                                            "plural": false,
                                            "selections": (v9 /*: any*/),
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "OIDCAuthIntegration",
                                            "kind": "LinkedField",
                                            "name": "oidc",
                                            "plural": false,
                                            "selections": (v9 /*: any*/),
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "GoogleAuthIntegration",
                                            "kind": "LinkedField",
                                            "name": "google",
                                            "plural": false,
                                            "selections": (v9 /*: any*/),
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "FacebookAuthIntegration",
                                            "kind": "LinkedField",
                                            "name": "facebook",
                                            "plural": false,
                                            "selections": (v9 /*: any*/),
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "CharCount",
                            "kind": "LinkedField",
                            "name": "charCount",
                            "plural": false,
                            "selections": [
                                (v5 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "min",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "max",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "CloseCommenting",
                            "kind": "LinkedField",
                            "name": "closeCommenting",
                            "plural": false,
                            "selections": [
                                (v6 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "MediaConfiguration",
                            "kind": "LinkedField",
                            "name": "media",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TwitterMediaConfiguration",
                                    "kind": "LinkedField",
                                    "name": "twitter",
                                    "plural": false,
                                    "selections": (v10 /*: any*/),
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "YouTubeMediaConfiguration",
                                    "kind": "LinkedField",
                                    "name": "youtube",
                                    "plural": false,
                                    "selections": (v10 /*: any*/),
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "GiphyMediaConfiguration",
                                    "kind": "LinkedField",
                                    "name": "giphy",
                                    "plural": false,
                                    "selections": [
                                        (v5 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "key",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "maxRating",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ExternalMediaConfiguration",
                                    "kind": "LinkedField",
                                    "name": "external",
                                    "plural": false,
                                    "selections": (v10 /*: any*/),
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "RTEConfiguration",
                            "kind": "LinkedField",
                            "name": "rte",
                            "plural": false,
                            "selections": [
                                (v5 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "strikethrough",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "spoiler",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "sarcasm",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Organization",
                            "kind": "LinkedField",
                            "name": "organization",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "name",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "memberBios",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "StaffConfiguration",
                            "kind": "LinkedField",
                            "name": "staff",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "staffLabel",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "adminLabel",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "moderatorLabel",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        (v7 /*: any*/)
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": (v2 /*: any*/),
                    "concreteType": "Story",
                    "kind": "LinkedField",
                    "name": "story",
                    "plural": false,
                    "selections": [
                        (v3 /*: any*/),
                        (v4 /*: any*/),
                        (v7 /*: any*/)
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "id": "264a42a5a8a4976dd2e8f9420158c3fe",
            "metadata": {},
            "name": "RefreshSettingsFetchQuery",
            "operationKind": "query",
            "text": null
        }
    } as any;
})();
(node as any).hash = 'd0a19a4d7cc4d8039d96500bd855db03';
export default node;
